// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
class _KeyEventProcessor {
    constructor() {
        this.lastPressedButton = null;
        this.currentButton = null;
        this.ControlPressed = false;
        this.ShiftPressed = false;
        this.AltPressed = false;
        this.OnKeyDown = new CustomEvent();
        this.OnKeyUp = new CustomEvent();
        this.OnKeyPress = new CustomEvent();
        this._initialization();
    }
    _initialization() {
        if (typeof window === 'undefined') {
            return;
        }
        const doc = document;
        doc.addEventListener('keydown', this.keyDown.bind(this));
        doc.addEventListener('keyup', this.keyUp.bind(this));
        doc.addEventListener('keypress', this.keyPress.bind(this));
    }
    keyDown(event) {
        this.setShiftAltCtrlState(event);
        this.setBtnCodes(event);
        this.OnKeyDown.Raise(this.currentButton, this.createModificatorStruct(), event);
    }
    keyUp(event) {
        this.setShiftAltCtrlState(event);
        this.setBtnCodes(event);
        this.OnKeyUp.Raise(this.currentButton, this.createModificatorStruct());
    }
    keyPress(event) {
        this.setShiftAltCtrlState(event);
        this.setBtnCodes(event);
        this.OnKeyPress.Raise(this.currentButton, this.createModificatorStruct());
    }
    setShiftAltCtrlState(event) {
        this.ControlPressed = event.ctrlKey;
        this.ShiftPressed = event.shiftKey;
        this.AltPressed = event.altKey;
    }
    setBtnCodes(event) {
        this.currentButton = event.which;
    }
    createModificatorStruct() {
        return { CTRL: this.ControlPressed, ALT: this.AltPressed, SHIFT: this.ShiftPressed };
    }
    isCtrlModOnly() {
        return this.ControlPressed && !this.AltPressed && !this.ShiftPressed;
    }
    isShiftModOnly(event) {
        return this.ShiftPressed && !this.ControlPressed && !this.AltPressed;
    }
    WithModButtons() {
        return this.ControlPressed || this.AltPressed || this.ShiftPressed;
    }
}
export const KeyEventProcessor = new _KeyEventProcessor();
export function GetDigit(keyCode) {
    const zeroCode = keyCode >= KeyCode.NUM_ZERO ? KeyCode.NUM_ZERO : KeyCode.ZERO;
    const digit = keyCode - zeroCode;
    return digit >= 0 && digit <= 9 ? digit : NaN;
}
export function IsPasteEvent(event) {
    return (event.ctrlKey === true || event.metaKey === true) && event.keyCode === KeyCode.V;
}
export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["CTRL"] = 17] = "CTRL";
    KeyCode[KeyCode["ESC"] = 27] = "ESC";
    KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
    KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["LEFT"] = 37] = "LEFT";
    KeyCode[KeyCode["UP"] = 38] = "UP";
    KeyCode[KeyCode["RIGHT"] = 39] = "RIGHT";
    KeyCode[KeyCode["DOWN"] = 40] = "DOWN";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["ZERO"] = 48] = "ZERO";
    KeyCode[KeyCode["A"] = 65] = "A";
    KeyCode[KeyCode["L"] = 76] = "L";
    KeyCode[KeyCode["V"] = 86] = "V";
    KeyCode[KeyCode["NUM_ZERO"] = 96] = "NUM_ZERO";
})(KeyCode || (KeyCode = {}));
